export class Store {

}
